<template>
  <Modal
    v-if="shown"
    :title="titleText"
    @close="show(false)"
    :close-on-click-outside="false"
    :width="500"
  >
    <template v-slot:body>
      <p class="title_tip">{{ $t("rejectModal.title.tip") }}</p>
      <el-form ref="form" label-position="top" :model="form" label-width="80px">
        <el-form-item :label="$t('rejectModal.reason')" required="">
          <el-input
            type="textarea"
            v-model="form.reason"
            :rows="8"
            resize="none"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="flex flex_between">
        <div></div>

        <md-button
          @click="save"
          :class="form.reason ? 'md-primary' : ''"
          :disabled="!form.reason"
          >{{ $t("trackPay.process.send") }}
        </md-button>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from "src/components/templates/modal/Modal";
import {trackPayApi} from "src/common/api/trackPayApi";
import {enumDef} from "@/common/enumDefs";

export default {
  components: {
    Modal,
  },
  props: {
    contractData: Object,
  },
  data() {
    let activeTypes = {
      shipment: "shipment",
      salesContract: "salesContract",
      trackers: "trackers",
      process: "process",
    };

    return {
      editMode: false,
      shown: false,
      activeTypes: activeTypes,
      activeType: activeTypes.shipment,
      modalType: "add",
      readOnly: false,
      form: {},
    };
  },
  computed: {
    titleText() {
      let title = this.$t("rejectModal.title");

      return title;
    },
  },
  methods: {
    save() {
      let option = { ...this.contractData, ...this.form };
      const { trackPayStats } = enumDef;
      option.status = trackPayStats.Rejected;
      option.rejectReason = this.form.reason;
      trackPayApi.debtor.reject(option).then(() => {
        this.show(false);
        this.$emit("success");
      });
    },
    show(value) {
      this.shown = value;
    },
    showDetail(data) {
      this.show(true);
    }
  }
};
</script>
<style lang="scss" scoped>
.title_tip {
  width: 300px;
  margin: auto;
  color: #8c939b;
}
.note-textarea {
  min-height: 200px;
  padding: 12px;
  background-color: #cbe9fe;
}
.el-form-item {
  text-align: left;
  /deep/ .el-form-item__label {
    padding: 0 !important;
    position: relative;
    font-weight: bold;
    padding-right: 10px;
    &::before {
      position: absolute !important;
      right: -10px !important;
    }
  }
  /deep/ .el-textarea__inner {
    background-color: #cbe9fe;
    border: none;
    font-weight: bold;
  }
}
</style>
